/**
 * File titles-hero.js.
 */

(() => {
    // Check if the script has already been executed
    if (window.hasScriptRun) {
        return;
    }

    // Set the flag to indicate that the script has run
    window.hasScriptRun = true;

	// Where to buy desktop
	// Get all the necessary elements
    const tabs = document.querySelectorAll('.tab-content');
    const tabRadioButtons = document.querySelectorAll('input[name="tab"]');
    const tabLabels = document.querySelectorAll('.tab-button label');

    // Display the content of the initially checked tab
    const initialTab = document.querySelector('input[name="tab"]:checked');
    const initialTabId = initialTab ? initialTab.getAttribute('id').replace('tab', 'content') : null;
    const initialTabContent = document.getElementById(initialTabId);
    if (initialTabContent) {
        initialTabContent.style.display = 'block';
    }

    // Add event listeners to the radio buttons and labels
    tabRadioButtons.forEach((radioButton, index) => {
        radioButton.addEventListener('change', () => {
            updateTabContent(index);
        });

        tabLabels[index].addEventListener('click', () => {
            radioButton.checked = true;
            updateTabContent(index);
        });
    });

    function updateTabContent(index) {
        // Hide all tab contents
        tabs.forEach(tab => {
            tab.style.display = 'none';
        });

        // Show the selected tab content
        const selectedTab = tabs[index];
        if (selectedTab) {
            selectedTab.style.display = 'block';
        }
    }
    // end

    // details accordion
    // Function to toggle accordion sections
    window.toggleAccordion = function(sectionNumber) {
        const accordion = document.getElementById('accordion' + sectionNumber);
        const icon = document.getElementById('icon' + sectionNumber);

        if (!accordion) {
            return;
        }

        if (activeAccordion && activeAccordion !== accordion) {
            activeAccordion.style.display = 'none';
            activeAccordion.classList.remove('active');
            activeAccordion.previousElementSibling.querySelector('.accordion-icon').src = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
        }

        if (accordion.style.display === 'block') {
            accordion.style.display = 'none';
            accordion.classList.remove('active');
            icon.src = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
            activeAccordion = null;
        } else {
            accordion.style.display = 'block';
            accordion.classList.add('active');
            icon.src = "/wp-content/themes/the-theme/resources/images/accordion-close.png";
            activeAccordion = accordion;
        }
    }

    // Desktop details accordion
    const desktopAccordion = document.getElementById('desktop-details-accordion');
    if (desktopAccordion) {
        const showMoreButtonDesktop = desktopAccordion.querySelector(".show-more-btn");
        const restOptionsDesktop = desktopAccordion.querySelector("#rest-options");
        const chevronAreaDesktop = desktopAccordion.querySelector(".chevron-area");

        let isHiddenDesktop = true;

        showMoreButtonDesktop.addEventListener("click", () => {
            if (isHiddenDesktop) {
                restOptionsDesktop.classList.add("show-rest");
                chevronAreaDesktop.classList.add("chevron-up");
            } else {
                restOptionsDesktop.classList.remove("show-rest");
                chevronAreaDesktop.classList.remove("chevron-up");
            }
            isHiddenDesktop = !isHiddenDesktop;
        });
    }

    // Mobile details accordion
    const mobileAccordion = document.getElementById('mobile-details-accordion');
    if (mobileAccordion) {
        const showMoreButtonMobile = mobileAccordion.querySelector(".show-more-btn");
        const restOptionsMobile = mobileAccordion.querySelector("#rest-options");
        const chevronAreaMobile = mobileAccordion.querySelector(".chevron-area");

        let isHiddenMobile = true;

        showMoreButtonMobile.addEventListener("click", () => {
            if (isHiddenMobile) {
                restOptionsMobile.classList.add("show-rest");
                chevronAreaMobile.classList.add("chevron-up");
            } else {
                restOptionsMobile.classList.remove("show-rest");
                chevronAreaMobile.classList.remove("chevron-up");
            }
            isHiddenMobile = !isHiddenMobile;
        });
    }
    // end

    window.onload = function() {
        // Open the first accordion section by default
        toggleAccordion(1);
    };

	// where to buy mobile
	let activeAccordion = null;

	  // JavaScript function to toggle accordion sections
        window.toggleAccordion = function(sectionNumber) {
            const accordion = document.getElementById('accordion' + sectionNumber);
            const icon = document.getElementById('icon' + sectionNumber);
            let iconSource = null;

            if(icon && icon.previousElementSibling && icon.previousElementSibling.tagName === 'SOURCE') {
                iconSource = icon.previousElementSibling;
            }

            if (!accordion) {
                return;
            }

            if (activeAccordion && activeAccordion !== accordion) {
                activeAccordion.style.display = 'none';
                activeAccordion.classList.remove('active');
                // Change the icon of the previously active accordion to 'accordion-open.png'
                activeAccordion.previousElementSibling.querySelector('.accordion-icon').src = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
                if (activeAccordion.previousElementSibling.querySelector('source')) {
                    activeAccordion.previousElementSibling.querySelector('source').srcset = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
                }
            }

            if (accordion.style.display === 'block') {
                accordion.style.display = 'none';
                accordion.classList.remove('active');
                if (icon) {
                    icon.src = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
                }
                if (iconSource) {
                    iconSource.srcset = "/wp-content/themes/the-theme/resources/images/accordion-open.png";
                }
                activeAccordion = null;
            } else {
                accordion.style.display = 'block';
                accordion.classList.add('active');
                if (icon) {
                    icon.src = "/wp-content/themes/the-theme/resources/images/accordion-close.png";
                }
                if (iconSource) {
                    iconSource.srcset = "/wp-content/themes/the-theme/resources/images/accordion-close.png";
                }
                activeAccordion = accordion;
            }
        }

	  // end

      // gallery
         window.openModal = function() {
            document.getElementById("myModal").style.display = "block";
        }

        window.closeModal = function() {
          document.getElementById("myModal").style.display = "none";
        }

        var slideIndex = 1;
        showSlides(slideIndex);

        window.plusSlides = function(n) {
          showSlides(slideIndex += n);
        }

        window.currentSlide = function(n) {
          showSlides(slideIndex = n);
        }

        function showSlides(n) {
          var i;
          var slides = document.getElementsByClassName("mySlides");
          var dots = document.getElementsByClassName("demo");
          var captionText = document.getElementById("caption");
          if (n > slides.length) {slideIndex = 1}
          if (n < 1) {slideIndex = slides.length}
          for (i = 0; i < slides.length; i++) {
              slides[i].style.display = "none";
          }
          
          slides[slideIndex-1].style.display = "block";
        }
        // end
})();
